/**
 * Widget store — provides the Redux store instance for widget bundles.
 *
 * We re-use the main application store so that all existing RTK Query API
 * slices, base queries, and middleware work without duplication. The
 * `baseQueries.ts` `prepareHeaders` callback reads auth state from the store
 * at runtime, so the store must contain compatible `auth` and `appView`
 * slices. Re-using the main store guarantees this.
 *
 * Trade-off: the widget bundle includes every API slice registered in the
 * main store (even those no widget uses). If bundle size becomes a concern,
 * extract a shared `createAppStore()` factory into `@/store/` and pass in
 * only the slices each consumer needs.
 */
import store from '@/store/store';

export { appViewReceived } from '@/store/appViewSlice';
export { loginSuccess, setCurrentRole } from '@/store/authSlice';

export const widgetStore = store;
export type WidgetStore = typeof store;
export type WidgetRootState = ReturnType<typeof store.getState>;
export type WidgetDispatch = typeof store.dispatch;
